import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "code-wrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "success-box"
}
const _hoisted_5 = { class: "success-icon-wrap" }
const _hoisted_6 = { class: "success-desc" }
const _hoisted_7 = { class: "highlight-email" }
const _hoisted_8 = {
  key: 0,
  class: "dialog-footer"
}
const _hoisted_9 = {
  key: 1,
  class: "dialog-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_CircleCheck = _resolveComponent("CircleCheck")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    title: "新用户激活 / 忘记密码",
    width: "440px",
    "close-on-click-modal": false,
    "before-close": _ctx.handleClose,
    "append-to-body": ""
  }, {
    footer: _withCtx(() => [
      (!_ctx.isSuccess)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
            _createVNode(_component_el_button, {
              onClick: _ctx.handleClose,
              type: "danger"
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode("取消", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "primary",
              loading: _ctx.loading,
              onClick: _ctx.handleSubmit
            }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode(" 确定 ", -1)
              ]))]),
              _: 1
            }, 8, ["loading", "onClick"])
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_9, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.handleClose
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode("我知道了", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ]))
    ]),
    default: _withCtx(() => [
      (!_ctx.isSuccess)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "dialog-notice" }, " 提示：输入您的工号和验证码，系统将向绑定的邮箱发送激活与密码设置链接（链接30分钟内有效）。 ", -1)),
            _createVNode(_component_el_form, {
              ref: "formRef",
              model: _ctx.form,
              rules: _ctx.rules,
              "label-width": "70px",
              onSubmit: _withModifiers(_ctx.handleSubmit, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "工号",
                  prop: "username"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.username,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.username) = $event)),
                      placeholder: "请输入工号或用户名",
                      clearable: "",
                      autocomplete: "off",
                      tabindex: "1"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "验证码",
                  prop: "verifyCode"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.verifyCode,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.verifyCode) = $event)),
                        placeholder: "请输入验证码",
                        clearable: "",
                        autocomplete: "off",
                        tabindex: "2",
                        onKeyup: _withKeys(_ctx.handleSubmit, ["enter"])
                      }, null, 8, ["modelValue", "onKeyup"]),
                      (_ctx.captchaImg)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.captchaImg,
                            alt: "点击刷新验证码",
                            title: "点击刷新验证码",
                            class: "captcha-img",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.refreshCaptcha && _ctx.refreshCaptcha(...args)))
                          }, null, 8, _hoisted_3))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules", "onSubmit"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_CircleCheck, { style: {"width":"48px","height":"48px","color":"#67c23a"} })
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "success-title" }, "邮件发送成功", -1)),
            _createElementVNode("div", _hoisted_6, [
              _cache[5] || (_cache[5] = _createTextVNode(" 系统已向绑定邮箱 ", -1)),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.maskedEmail), 1),
              _cache[6] || (_cache[6] = _createTextVNode(" 发送了激活与密码设置链接。 ", -1))
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "success-subdesc" }, " 请在 30 分钟内查收邮件并完成新密码设置。 ", -1))
          ]))
    ]),
    _: 1
  }, 8, ["modelValue", "before-close"]))
}